import TheGrid from '@/views/stars/shipto_objectives/grid'
import Edit from '@/views/stars/shipto_objectives/edit'
import Importer from '@/views/stars/shipto_objectives/import'

export default {
  path: '/stars/shipto_objectives',
  redirect: '/stars/shipto_objectives/index',
  name: 'shipto_objectives',
  meta: {
    auth: {
      redirect: {
        name: 'shipto_objectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'ShipTo Objetivos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'shipto_objectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'shipto_objectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'shipto_objectives.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'shipto_objectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
